module.exports = __webpack_public_path__ + "static/assets/999649b8d77ea4f04e0dca31326090c1.svg";